import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5d1204e3&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5d1204e3&scoped=scoped&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=5d1204e3&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1204e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d1204e3')) {
      api.createRecord('5d1204e3', component.options)
    } else {
      api.reload('5d1204e3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5d1204e3&scoped=true&", function () {
      api.rerender('5d1204e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trial/channel/index.vue"
export default component.exports